const en = {
  navbar: {
    about: "About",
    content: "Educational Content",
    features: "App Features",
    trust: "Notice",
    contact: "Contact Us",
    parent: "Parent Area",
  },

  
  header: {
    lines: [
      "The Khotoua app is the ideal companion for elementary school",
      "children who want to enhance their educational experience in a fun",
      "and engaging way.",
      "An application prepared by educational experts in light of school",
      "curricula and the best contemporary educational methods and",
      "approaches."
    ],
    download: "Download the app ",
  },

  
  about: {
  title: "About",
  lines: [
    "Khotoua: It is a revolutionary educational application that reinvents primary learning for children from the age of 5 to 12.",
    "By integrating augmented reality and artificial intelligence, it offers an immersive experience and unique interaction. Scenarios filled with 2D/3D gameplay.",
    "Designed to stimulate cognitive skills in a fun and creative way, and enhance personal learning."
  ],
},

  educational: {
    title: 'Educational Content',
    items: [
      'Educational games',
      'Augmented reality',
      'Scientific laboratory',
      'Life Skills',
      'Conversation arts',
      'Helpful Videos and Stories',
    ],
  },

  features: {
    sectionTitle: {
      first: 'App',
      second: 'Features ',
    },
    steps: [
      'Content compatible with the program',
      'Overcoming difficulties',
      'Reality increase',
      'The Bloom Pyramid',
      'What the app offers parents',
    ],
    heading: 'Content compatible with the program',
    paragraphs: [
      'In the "Khotoua" application, we are keen to match all the subjects',
      'provided with the official programs of the primary stage and when',
      'they exceed them, in order to assign them and enrich and expand its',
      '.content',
      'Our professional educational and multi-level audit team ensured proper',
      'preparation of educational activities and educational games based on',
      '.the curriculum and official approaches'
    ],
  },

  
  teacher: {
    title: "Notice",
    subtitle: "The Teachers",
    downloadTitleAlt: "Trusted by title image",
    testimonials: [
      {
        name: "Nawwi Eya",
        title: "Teacher",
        comment:
        "Have fun and learn on a unique journey to explore the world in an exciting and entertaining way. This is the Khatwa app, the Tunisian innovator that combines games and learning in one... to reinforce educational concepts with individual assessments and development reports. Congratulations!"
      },
      {
        name: "Jervel Nejm Eddin",
        title: "Retired, distinguished, and senior primary school teacher",
        comment:
        "It is a solid step towards the learner's advancement towards excellence, building their knowledge on solid foundations and rising to the best. They learn in an atmosphere of pleasure, relying on the exercises offered to them, which aim to improve their acquisitions in a wonderful way that leads them to excellence."
      },
      {
        name: "Rayess Habiba",
        title: "Arabic teacher for beginners",
        comment: 
        "In the age of technology, two steps are necessary: ​​one step towards knowledge, one step towards technology and one step towards implementation."
      },
      {
        name: "Ziraoui Mohammed",
        title: "Arabic teacher for beginners",
        comment:
        "These are modern and innovative educational capsules, compatible with official curricula and responding to the distinctive intelligence and learning styles of each learner. They address difficulties and develop the student's skills and abilities with ease of use."
      },
      {
        name: "Hbibi Selma",
        title: "Head teacher above the rank of primary school",
        comment: 
        "Every beginning has a first step. Applying the first step will be the first step towards excellence."
      },
    ],
    images: {
      topCloudsAlt: "Clouds at the top",
      bottomDecorAlt: "Clouds at the bottom",
      lampeAlt: "Lamp image",
      staraloneAlt: "Star decoration",
      notebookAlt: "Notebook decoration",
      astroAlt: "Astronaut decoration",
    },
  },

  contact: {
    sectionTitle: { first: 'Contact', second: 'us' },
    cards: [
      { title: 'Customer Service', line: '078 078 56 216+' },
      { title: 'Email',            line: 'contact@khotoua.com' },
      { title: 'Social Media' },
    ],
    socialsAlt: {
      tiktok: 'TikTok',
      facebook: 'Facebook',
      instagram: 'Instagram',
      linkedin: 'LinkedIn',
      youtube: 'YouTube',
    },
  },

  download: {
    titleAlt : 'Download the app now',
    titleText : 'Download the App',
    description : 
    [
      'Give your child the perfect companion to help them thrive',
      'Enjoy their educational experience in a fun and exciting way',
    ],
    cta : 'Download the app',
  },

  footer: {
    title: 'For Every Achievement, a Step...',
    sectionsCol1: [
      { id: 'about', label: 'About' },
      { id: 'content', label: 'Educational content' },
      { id: 'features', label: 'Public policy' },
    ],
    sectionsCol2: [
      { id: 'trust', label: 'Notice' },
      { id: 'contact', label: 'App Features' },
      { id: 'download', label: 'Contact us' },
    ],
    logoAlt: 'Khotwa Logo',
    orangeLineAlt: 'Orange line',
    productBy: 'Executive Producer :',
  },

  privacy: {
    title: 'Privacy Policy',
    lastUpdated: 'Last Updated:',
    introduction: 'At Khotoua, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application.',
    sections: [
      {
        title: 'Information We Collect',
        content: 'We collect information you provide directly to us, including: name and profile information (such as profile picture), device information (such as device ID, operating system, and mobile network), usage data (such as features used, time spent in the app), and diagnostic data (such as crash logs and performance data).',
      },
      {
        title: 'How We Use Your Information',
        content: 'We use the information we collect to: provide and improve our services, personalize your experience, communicate with you about updates and new features, analyze usage patterns to enhance app performance, and ensure security and prevent fraud.',
      },
      {
        title: 'Data Sharing and Disclosure',
        content: 'We do not sell your personal information. We may share information with: service providers who assist us in operating the app, analytics partners to help us understand app usage, and legal authorities when required by law.',
      },
      {
        title: 'Data Security',
        content: 'We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.',
      },
      {
        title: 'Children\'s Privacy',
        content: 'Our app is designed for children ages 5-12. We collect minimal personal information from children, with parental consent. Parents can review, update, or delete their child\'s information at any time.',
      },
      {
        title: 'Your Rights',
        content: 'You have the right to: access your personal information, request correction of inaccurate data, request deletion of your data, object to processing of your data, and export your data in a portable format.',
      },
      {
        title: 'Account Deletion',
        content: 'To request deletion of your account and personal data, please send an email to contact@khotoua.com with your account email address. We will process your request within 30 days.',
      },
      {
        title: 'Changes to This Policy',
        content: 'We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new policy on this page and updating the "Last Updated" date.',
      },
      {
        title: 'Contact Us',
        content: 'If you have any questions about this Privacy Policy, please contact us at contact@khotoua.com.',
      },
    ],
  },

};

export default en;
